export default "__VITE_ASSET__CW4EnMj0__"